/**
 * Throttle a function so that it is invoked at most once per the specified
 * number of seconds or, if not specified, at most once per animation frame.
 *
 * @param {Function} callback The function to throttle.
 * @return {Function} The throttled function.
 */
export default function throttle (callback, wait, immediate) {
  if (wait === true || wait === false) {
    immediate = wait
    wait = undefined
  }

  let timeout
  let result
  let args
  let context

  function invoke () {
    result = callback.apply(context, args)
    context = args = null
  }

  function later () {
    timeout = null

    if (!immediate) {
      invoke()
    }
  }

  return function throttled () {
    context = this
    args = arguments

    if (!timeout) {
      if (wait === undefined) {
        timeout = requestAnimationFrame(later)
      } else {
        timeout = setTimeout(later, wait)
      }

      if (immediate) {
        invoke()
      }
    }

    return result
  }
}
